import { render } from "./DispatcherProfile.vue?vue&type=template&id=4b4cd3bc"
import script from "./DispatcherProfile.vue?vue&type=script&lang=js"
export * from "./DispatcherProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__